<template>
  <div class="supervision">
    <header>
      <div class="header-container">
        <div class="image">
          <img
            src="../../src/assets/praxis-lambrette-supervision.png"
            alt="Bild Supervision"
          />
        </div>
        <div class="text">
          <h1>Supervision</h1>
          <p>
            Ich arbeite als Supervisorin für Psychotherapeutinnen und
            Psychotherapeuten in Ausbildung. Zudem biete ich Team- und
            Fallsupervisionen sowie Selbsterfahrung für Einzelpersonen und
            Gruppen an. Bitte
            <a href="mailto:info@praxis-lambrette.de">kontaktieren</a> Sie mich
            bei Interesse.
          </p>
          <h2>Seminare</h2>
          <p>
            Auf
            <a href="https://blaugrau.org/" target="_blank">blaugrau.org</a>
            biete ich mein Seminar
            <a
              href="https://blaugrau.org/das-warten-auf-kinder/"
              target="_blank"
              >"Das Warten auf Kinder - Psychotherapeutische Unterstützung bei
              unerfülltem Kinderwunsch"</a
            >
            für Fachkolleginnen und -kollegen an. Sie können das Seminar direkt
            über die Website buchen.
          </p>
        </div>
      </div>
    </header>
    <Contact></Contact>
  </div>
</template>

<script>
import Contact from "../components/Contact.vue";

export default {
  components: {
    Contact
  },
  metaInfo: {
    title: "Supervision – Dipl.-Psych. Katrin Lambrette",
    meta: [
      {
        name: "description",
        content:
          "Supervision – Ich arbeite als Supervisorin für Psychotherapeut:innen in Ausbildung. Zudem biete ich Team- und Fallsupervisionen sowie Selbsterfahrung für Einzelpersonen und Gruppen an. Seminare – Auf blaugrau.org biete ich mein Seminar 'Das Warten auf Kinder - Psychotherapeutische Unterstützung bei unerfülltem Kinderwunsch' für Fachkolleginnen und -kollegen an."
      }
    ],
    htmlAttrs: {
      lang: "de",
      amp: true
    }
  }
};
</script>

<style lang="scss" scoped>
h1,
h2 {
  color: $supervision-color;
}

header {
  @media screen and (min-width: 992px) {
    .header-container {
      .text {
        background-image: url(../../src/assets/praxis-lambrette-supervision-signet-transparent.png);
        background-position: bottom right;
        padding: 0% 10% 0 0;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    .header-container .text {
      padding: 5% 15% 0 0;
    }
  }
}
</style>
